import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Head from 'next/head';
import Script from 'next/script';
import PropTypes from 'prop-types';
import parseHTML, { attributesToProps, domToReact } from 'html-react-parser';
import { components, renderChildren } from '@blaze-cms/react-page-builder';
const {
  code: CodeComponent
} = components;
const ALLOWED_TAGS = ['style', 'script', 'link'];
const BLAZE_CHILDREN_TAG = 'blazeshorthandchildren';
const ShortHandStory = ({
  children,
  shorthandData,
  includeMetaTagsInHead,
  loadScriptOnLoad = false
}) => {
  if (!shorthandData) return null;
  const {
    bodyInline,
    head
  } = shorthandData;
  const headParserOptions = {
    replace: domNode => {
      // convert style tag content to childen instead of dangerously set html
      // this resolves an issue with large style content being split into multiple text nodes and not matching in the head
      if (domNode.attribs && domNode.name === 'style') {
        const props = attributesToProps(domNode.attribs);
        return /*#__PURE__*/React.createElement("style", _extends({}, props, {
          key: domNode.attribs.className
        }), domToReact(domNode.children, headParserOptions));
      }
      if (!loadScriptOnLoad && domNode.attribs && domNode.name === 'script') {
        const props = attributesToProps(domNode.attribs);
        const html = domNode.children ? domNode.children.map(child => child.data).join('') : '';
        return /*#__PURE__*/React.createElement(Script, _extends({}, props, {
          key: domNode.attribs.className,
          dangerouslySetInnerHTML: {
            __html: html
          },
          strategy: "afterInteractive" // defer loading of third party scripts to protect react hydration
        }));
      }
    }
  };
  let renderCounter = 0;
  const codeParserOptions = {
    replace: domNode => {
      if (domNode.name === BLAZE_CHILDREN_TAG) {
        renderCounter += 1;
        return /*#__PURE__*/React.createElement(React.Fragment, null, renderChildren(children, {
          renderCounter
        })); // wrapping required
      }
    }
  };
  const scriptTags = [];
  const headCode = head.map(headPart => {
    const parsedCode = parseHTML(headPart, headParserOptions);
    let codeArray = parsedCode;
    if (!Array.isArray(codeArray)) codeArray = [codeArray];
    return codeArray.filter(item => {
      const {
        type
      } = item;
      if (type === Script) {
        scriptTags.push(item);
        return false;
      }
      return includeMetaTagsInHead ? true : ALLOWED_TAGS.includes(type);
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, {
    key: "head"
  }, headCode), scriptTags, /*#__PURE__*/React.createElement("div", {
    key: "code",
    className: "shorthand-wrapper"
  }, /*#__PURE__*/React.createElement(CodeComponent, {
    code: bodyInline,
    parserOptions: codeParserOptions
  })));
};
ShortHandStory.propTypes = {
  shorthandData: PropTypes.object,
  includeMetaTagsInHead: PropTypes.bool,
  loadScriptOnLoad: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.array])
};
ShortHandStory.defaultProps = {
  shorthandData: null,
  includeMetaTagsInHead: false,
  loadScriptOnLoad: false,
  children: null
};
export default ShortHandStory;
//# sourceMappingURL=ShorthandStory.js.map